import { render, staticRenderFns } from "./LoadFilters.vue?vue&type=template&id=4e23b6a5"
import script from "./LoadFilters.vue?vue&type=script&lang=ts"
export * from "./LoadFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports